module.exports = __webpack_public_path__ + "static/media/tick.4835c92c.svg";